import React from "react";
import { connect } from "react-redux";
import { Content, Container } from "../../pages/Template";
import { AppState } from "../../store";

import Header from "./Header";
import SplitView from "./SplitView";

type OwnProps = {
    match: {
        params: {
            doc_id: string;
        };
    };
};
const mapStateToProps = (
    _: AppState,
    {
        match: {
            params: { doc_id },
        },
    }: OwnProps
) => ({
    doc_id: parseInt(doc_id),
});
type StateProps = ReturnType<typeof mapStateToProps>;

type Props = StateProps & OwnProps;

class TranslatePage extends React.Component<Props> {
    static paths = ["/app/translate/:doc_id/"];
    static requiresAuth = true;

    render() {
        return (
            <Content>
                <Container width="1000px">
                    <Header />
                    <SplitView />
                </Container>
            </Content>
        );
    }
}

export default connect(mapStateToProps)(TranslatePage);
